import { render, staticRenderFns } from "./TileCogs.vue?vue&type=template&id=dff2e078&"
import script from "./TileCogs.vue?vue&type=script&lang=js&"
export * from "./TileCogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports